import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from '../context/AuthContext';
import ProtectedRoute from './protectedRoute';
import PrivateRoute from './privateRoute';
import { ToastContainer } from 'react-toastify';
import { Login } from '../modules/auth/login';
import Overview from '../modules/Overview/Overview';
import { Teams } from '../modules/teams/teams';
import AddTeam from '../modules/teams/add-edit-team';
import { Users } from '../modules/users/users';
import AddUser from '../modules/users/add-edit-user';
import { Documents } from '../modules/documents/documents';
import UploadDocument from '../modules/documents/upload-documents';
import { TranslationPage } from '../modules/translation/translation-page';
import { PostEditing } from '../modules/postEditing/postEditing';
import NewTranslation from '../modules/translation/new-translation';
import { Translation } from '../modules/translation/translation';
import AssignedTeams from '../modules/documents/assignedTeams';
import AssignUser from '../modules/postEditing/assignUser';
import { Resources } from '../modules/resources/resources';
import { AddResource } from '../modules/resources/add-resource';
import EmailLogin from '../modules/auth/emailLogin';
import ForgotPassword from '../modules/auth/forgotPassword';
import ResetPassword from '../modules/auth/resetPassword';
import { Folders } from '../modules/folders/folders';
import AddFolder from '../modules/folders/add-edit-folder';
import ViewFolder from '../modules/folders/view-folder';
import ViewDocument from '../modules/documents/viewDocument';
import { RecentTranslations } from '../modules/translation/recent-translation';
import Register from '../modules/company/register';
import ViewRecentTranslation from '../modules/translation/view-recent-translation';
import { EditDocument } from '../modules/postEditing/editDocument';
import TitleUpdater from '../components/titleUpdater';
import { SelectVersion } from '../modules/auth/slectVersions';
import ProfileScreen from '../modules/profile/profile';
import RedirectLogin from '../modules/auth/redirectLogin';
import VerifyTwoFA from '../modules/auth/verifyTwoFA';
import ViewTeam from '../modules/teams/view-team';
import { NewEditDocument } from '../modules/postEditing/newEditDocument';
import PostEditSummary from '../modules/postEditing/postEditSummary';
import { OkapiDocumentSegments } from '../modules/postEditing/docSegments';
import DocEditSummary from '../modules/postEditing/docEditSummary';
import { ComplianceReports } from '../modules/compliance/compliance-list';
import ComplianceReportPage from '../modules/compliance/compliance-report';
import { Logs } from '../modules/systemLogs/logs';
import SystemLogView from '../modules/systemLogs/systemLogView';

const MainRoute = () => {
    return (
        <>
            <Router>
                <AuthProvider>
                <TitleUpdater />
                <Routes>
                    <Route element={<ProtectedRoute />}>
                        <Route path='/' element={<Login />} />
                        <Route path='/email-login' element={<EmailLogin />} />
                        <Route path='/forgot-password' element={<ForgotPassword />} />
                        <Route path='/reset-password/:token' element={<ResetPassword />} />
                        <Route path='/company/register' element={<Register />} />
                        <Route path='/select-version' element={<SelectVersion />} />
                        <Route path='/re-direct' element={<RedirectLogin />} />
                        <Route path='/verify-2fa' element={<VerifyTwoFA />} />

                    </Route>

                    <Route element={<PrivateRoute />}>
                        <Route path='/over-view' element={<Overview />} />
                        <Route path='/teams' element={<Teams />} />
                        <Route path='/add-team' element={<AddTeam />} />
                        <Route path='/edit-team/:id' element={<AddTeam />} />
                        <Route path='/view-team/:id' element={<AddTeam />} />
                        <Route path='/team-view/:id' element={<ViewTeam />} />
                        <Route path='/users' element={<Users />} />
                        <Route path='/add-user' element={<AddUser />} />
                        <Route path='/edit-user/:id' element={<AddUser />} />
                        <Route path='/view-user/:id' element={<AddUser />} />

                        <Route path='/documents' element={<Documents />} />
                        <Route path='/upload-documents' element={<UploadDocument />} />
                        <Route path='/edit-documents/:id' element={<UploadDocument />} />
                        <Route path='/view-documents/:id' element={<ViewDocument />} />

                        <Route path='/folders' element={<Folders />} />
                        <Route path='/add-folder' element={<AddFolder />} />
                        <Route path='/edit-folder/:id' element={<AddFolder />} />
                        <Route path='/view-folder/:id' element={<ViewFolder />} />


                        <Route path='/new-translation' element={<NewTranslation />} />
                        <Route path='/recent-translation' element={<RecentTranslations />} />
                        <Route path='/view-recent-translation/:id' element={<ViewRecentTranslation />} />
                        <Route path='/translation-page' element={<TranslationPage />} />
                        <Route path='/translation' element={<Translation />} />

                        <Route path='/post-editing' element={<PostEditing />} />
                        <Route path='/assign-teams' element={<AssignedTeams />} />
                        <Route path='/assign-user' element={<AssignUser />} />
                        <Route path='/resources' element={<Resources />} />
                        <Route path='/add-resources' element={<AddResource />} />
                        <Route path='/add-translation-memory' element={<AddResource />} />

                        <Route path='/post-edit/:id' element={<NewEditDocument />} />
                        <Route path='/post-edit/summary' element={<PostEditSummary />} />

                        <Route path='/post-edit-okapi/:id' element={<OkapiDocumentSegments />} />
                        <Route path='/post-edit-okapi/summary/:id' element={<DocEditSummary />} />


                        <Route path='/profile' element={<ProfileScreen />} />
                        <Route path='/logs' element={<Logs />} />
                        <Route path='/logs/:id' element={<SystemLogView />} />
                        {/* <Route path='/compliance-reports' element={<ComplianceReports />} />

                        <Route
                            path="/compliance-report/:id"
                            element={<ComplianceReportPage />}
                        /> */}



                    </Route>

                </Routes>
                <ToastContainer limit={2} />
                </AuthProvider>
            </Router>
        </>
    )
}

export default MainRoute